module.exports = __webpack_public_path__ + "img/horizontal_3_1_5012.66e4a27f.png";